import type { ThemeOptions } from "@mui/material/";

export const ProColorThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#006BB6",
      dark: "#1E5B8F",
    },
    secondary: {
      main: "#EF3E42",
    },
    warning: {
      main: "#F57C00",
    },
    success: {
      main: "#388E3C",
    },
    error: {
      main: "#EF3E42",
    },
    background: {
      default: "#E6EBF0",
      defaultDark: "#dbe8f3",
      defaultDarker: "#c0d8ea",
      paper: "#FAFAFA",
    },
  },
};
